import React from 'react';

import ProfileTabs from './Tabs';

function Profile() {
    return <ProfileTabs />;
}

export default React.memo(Profile);
